import { useTranslation } from "react-i18next";
import type { Invoice } from "../../../../../api/invoices";
import { isCreditNote } from "../../../../../lib/fiscalInvoice";
import { NoticeBanner } from "./NoticeBanner";

interface Props {
  invoice: Invoice;
  isNarrow: boolean;
}

/**
 * Лентата над прегледа на документ от фискалното устройство (фискална
 * фактура или кредитно известие): защо липсват „Печат", „Анулирай" и
 * „Редактирай" — оригиналът е бонът (BE отказва и трите с 409), а фискалната
 * фактура не се анулира, а се кредитира с кредитно известие за цялата сметка
 * (`FiscalInvoiceCreditAction`). Под нея — кой апарат и кой бон.
 */
export function FiscalInvoicePreviewNotice({ invoice, isNarrow }: Props) {
  const { t } = useTranslation();
  const device = [
    invoice.fiscal_device_serial
      ? t("fiscalInvoice.preview.deviceSerial", { serial: invoice.fiscal_device_serial })
      : null,
    invoice.fiscal_receipt_number
      ? t("fiscalInvoice.preview.receipt", { receipt: invoice.fiscal_receipt_number })
      : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      className={`flex flex-col gap-1.5 border-b border-pos-line2 bg-pos-card ${
        isNarrow ? "px-4 py-2.5" : "px-6 py-3"
      }`}
    >
      <NoticeBanner
        tone="info"
        text={
          isCreditNote(invoice)
            ? t("fiscalInvoice.preview.creditNote", { number: invoice.credit_note_of ?? "—" })
            : t("fiscalInvoice.preview.fiscalInvoice")
        }
      />
      {device && (
        <span className="font-pos-mono text-[12px] font-semibold text-pos-soft">{device}</span>
      )}
    </div>
  );
}
